export default __webpack_public_path__ + "static/media/schedule-now.c993e549.svg";